<template>
  <div class="autocomplete">
    <input
        type="text"
        id="toBeReturnedFieldObj.filteredName"
        name="toBeReturnedFieldObj.filteredName"
        class="form-control w-100 mt-1"
        @input="onChange"
        v-model="toBeReturnedFieldObj.filteredName"
        autocomplete="off"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        v-validate="validationRules"
        data-vv-validate-on="input"
        :disabled="isDisabled"
        @focus="onFocus"
        @blur="validateIfSelectedFromDropDown"
        @onfocusout="checkForValidation"
        data-lpignore="true"
        ref="inputRef"
    />
    <div class="icon-container" v-if="apiDataLoading">
      <i class="loader"></i>
    </div>

    <span
        class="text-danger input-error-text"
        v-if="errors.has('toBeReturnedFieldObj.filteredName') && !isOpen"
    > Supplier name is required<br></span>
    <ul
        :class="autocompleteAPIResultsHeight"
        v-show="isOpen"
        class="autocomplete-results"
        ref="scrollContainer"
        v-if="!apiDataLoading"
    >
      <li ref="options"
          v-for="(result, i) in filteredApiResponse"
          :key="i"
          @click="setAPIResult(result)"
          @mousedown="preventBlur($event)"
          class="autocomplete-result"
          :class="{ 'is-active': i === arrowCounter }"
      >
        {{ result.filteredName}}  <span v-if="result.supplierNumber" class="text-muted"> - {{result.supplierNumber}}</span>
      </li>
    </ul>
    <ul
        v-if="apiDataLoading"
        v-show="isOpen"
        class="autocomplete-results"
        :class="autocompleteAPIResultsHeight"
    >
      <li class="text-muted" v-if="apiDataLoading">
        Loading currently available suppliers...
      </li>
    </ul>
  </div>
</template>


<script>
import debounce from "lodash/debounce";
import api from "@/api"
import FORM_LABELS from "@/store/FormLabels";
import CONSTANTS from "@/store/constants";
import PaymentFormsMixin from "../mixins/PaymentFormsMixin";

export default {
  name: 'SupplierAutoComplete',
  props: {
    currentSelection: String,
    isRequired: Boolean,
    isDisabled: Boolean,
    isSupplier: {
      type: Boolean,
      default: false
    },
    isFormNonPo: {
      type: Boolean,
      default: false
    },
    isSupplierNameFetchedFromSupplierId: {
      type: Boolean,
      default: false
    },
    isOneInTakeForm: {
      type: Boolean,
      default: false
    }
  },
  mixins:[PaymentFormsMixin],
  inject: ["$validator"],
  data() {
    return {
      FORM_LABELS: FORM_LABELS,
      isOpen: false,
      toBeReturnedFieldObj: {},
      arrowCounter: -1,
      apiResponse: [],
      apiDataLoading: false,
      ARROW_COUNTER_DEFAULT_INDEX: -1,
      autocompleteData: [],
      isAutoCompleteInFocus: false
    };
  },
  computed: {
    filteredApiResponse() {
      let filteredAPIResponse = this.apiResponse
      if(filteredAPIResponse && filteredAPIResponse.length > 0) {
        filteredAPIResponse.sort((a, b) => (a.supplierName > b.supplierName) ? 1 : -1)
      }
      return filteredAPIResponse
    },
    validationRules() {
      if(this.isFormNonPo)
        return 'required|max:70'
      else if(this.isRequired)
        return 'required'
      else
        return ''
    },
    autocompleteAPIResultsHeight() {
      return this.apiResponse.length >= 4 ? 'autocomplete-results-height-100' : 'autocomplete-results-height-auto'
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.toBeReturnedFieldObj.filteredName = this.currentSelection
    this.toBeReturnedFieldObj.name = this.currentSelection
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    validateIfSelectedFromDropDown() {
      if(this.isOneInTakeForm)
      {
        this.isOpen = false;
        this.isAutoCompleteInFocus = false
        this.$emit('OnBlurAutoComplete')
      }
      if(this.toBeReturnedFieldObj.filteredName !== this.toBeReturnedFieldObj.name && this.isFormNonPo){
        this.toBeReturnedFieldObj.name = this.toBeReturnedFieldObj.filteredName
        this.toBeReturnedFieldObj.filteredName = ''
      }
    },
    checkForValidation(){
      this.$validator.validateAll()
    },
    setAPIResult(result) {
      this.toBeReturnedFieldObj.filteredName = this.isFormNonPo ? this.getSupplierFullName(result) : result.filteredName
      this.toBeReturnedFieldObj.name = this.toBeReturnedFieldObj.filteredName
      if(this.isFormNonPo) {
        result.supplierName = this.getSupplierFullName(result)
      }
      if(this.isOneInTakeForm){
        this.$emit('supplierNameSelectedFromDropdown',true)
      }
      this.$emit('onItemSelected', result)
      this.updateCompanyCodeAndText(result)
      this.isOpen = false
      this.trackAutoCompleteSelection()
    },
    fixScrolling(){
      if( this.$refs.options[this.arrowCounter] &&  this.$refs.options[this.arrowCounter].clientHeight) {
        const liH = this.$refs.options[this.arrowCounter].clientHeight;
        this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter
      }
    },
    onFocus() {
      if(this.isOneInTakeForm)
      {
        this.isAutoCompleteInFocus = true
        this.$emit('newNameFieldEvent',false)
      }
      this.currentSelection !== this.toBeReturnedFieldObj.name ? this.onChange() : null
    },
    onChange() {
      if(!this.isSupplierFetchedFromSupplierId) {
        this.validateUserClearedInput()

        this.searchAndDebounce(this)

        if(this.apiResponse.length === 0){
          this.isOpen = false;
        }
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
        this.arrowCounter = this.ARROW_COUNTER_DEFAULT_INDEX;
      }
    },
    searchAndDebounce: debounce(
        that => {
          that.getSupplierAutocompleteResults();
        },
        500,
        { leading: true }
    ),
    validateUserClearedInput() {
        this.$emit('onItemSelected',
            {filteredName: this.toBeReturnedFieldObj.filteredName
              , name: this.toBeReturnedFieldObj.filteredName})
    },
    getSupplierFullName(resultObj) {
      return resultObj.supplierNameContinued ? resultObj.supplierName + ' ' + resultObj.supplierNameContinued : resultObj.supplierName
    },
    getSupplierAutocompleteResults() {
      this.apiResponse = []
      if(this.toBeReturnedFieldObj.filteredName && this.toBeReturnedFieldObj.filteredName.length > CONSTANTS.MINIMUM_CHAR_LENGTH_FOR_AUTOCOMPLETE) {
        this.apiDataLoading = true
        if (this.isFormNonPo){
          let supplierData = {}
          supplierData.supplierName = this.toBeReturnedFieldObj.filteredName
          api.getNONPOAutocompleteSupplierResults(this.updateSupplierAutoCompleteData(supplierData)).then((res) => {
            let autocompleteResult = res.data.data.fetchInvoiceDetail.invoiceResponse.invoiceDetails
            if (autocompleteResult && autocompleteResult.length > 0) {
              autocompleteResult.forEach(result => {
                result.filteredName =  this.getSupplierFullName(result)
              })
              this.autocompleteData = autocompleteResult
              this.apiResponse = this.getUniqueSupplierIdAndCompanyCodeList(autocompleteResult)
              this.isOpen = true
            }else{
              this.apiResponse = []
              this.isOpen = false
              this.$emit('noAutoCompleteResults',FORM_LABELS.NAME_OF_SUPPLIER)
            }
          }).finally(() => {
            this.apiDataLoading = false
          })
        }else{
          let validateSupplier = false
          api.getAutocompleteSupplier(this.toBeReturnedFieldObj.filteredName, validateSupplier).then((res) => {
            let autocompleteResult = res.data.result
            if(autocompleteResult && autocompleteResult.length > 0) {
              autocompleteResult.forEach(result => {
                result.filteredName = this.isFormNonPo ? result.name : result.u_vendor_parent
              })
              if(!this.isFormNonPo) {
                this.apiResponse = this.getUniqueSupplierIdAndCompanyCodeList(autocompleteResult)
              } else
                this.apiResponse = autocompleteResult
                this.isOpen = this.isOneInTakeForm ? this.isAutoCompleteInFocus : true
            }
          }).finally(() => {
            this.apiDataLoading = false
            if(this.isOneInTakeForm){
        this.$emit('supplierNameSelectedFromDropdown',false)
      }
          })
        }
      }
    },
    //For non-po web form we need unique supplier name and supplier number combination.
    //hence we check if supplierName - supplierNumber combination is already present for uniqueSuppliersList
    getUniqueSupplierIdAndCompanyCodeList(suppliersList) {
      let uniqueSuppliersList = []
      suppliersList.forEach((supplier) => {
        let isSupplierExist = this.isFormNonPo ?
            uniqueSuppliersList.find(item => item.supplierName.trim().toLowerCase() === supplier.supplierName.trim().toLowerCase()
                && item.supplierNumber.trim().toLowerCase() === supplier.supplierNumber.trim().toLowerCase()) :
            uniqueSuppliersList.find(item => item.u_vendor_parent.trim().toLowerCase() === supplier.u_vendor_parent.trim().toLowerCase())
        if (!isSupplierExist){
          uniqueSuppliersList.push(supplier)
        }
      })
      return uniqueSuppliersList
    },
    onArrowDown() {
      if (this.arrowCounter < this.apiResponse.length) {
        this.arrowCounter = this.arrowCounter + 1;
      } else {
        this.arrowCounter = 0
      }
      this.fixScrolling()
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.fixScrolling()
      }
    },
    updateWithCurrentValue() {
      if (this.isFormNonPo) {
        this.toBeReturnedFieldObj.supplierNumber = this.apiResponse[this.arrowCounter].supplierNumber
        this.toBeReturnedFieldObj.filteredName = this.getSupplierFullName(this.apiResponse[this.arrowCounter])
        this.toBeReturnedFieldObj.supplierName = this.getSupplierFullName(this.apiResponse[this.arrowCounter])
      }
    },
    onEnter(e) {
      e.preventDefault();
      if (this.toBeReturnedFieldObj.filteredName) {
        if(this.arrowCounter > this.ARROW_COUNTER_DEFAULT_INDEX) {
          this.updateWithCurrentValue()
        }
        this.isOpen = false;
        this.arrowCounter = this.ARROW_COUNTER_DEFAULT_INDEX;
        this.$emit('onItemSelected', this.toBeReturnedFieldObj)
        this.trackAutoCompleteSelection()
      }
    },
    trackAutoCompleteSelection() {
      let event = 'Supplier Central - Autocomplete supplier selected'
      let subEvent = 'supplierName - ' + this.toBeReturnedFieldObj.filteredName
      this.$hhMixpanel.trackEvent(event, {subEvent})
    },
    updateCompanyCodeAndText(supplierDetailsList) {
      let eligibleCompanyCodeAndTextList = []
      this.autocompleteData.forEach(data => {
        if(supplierDetailsList.supplierName === data.supplierName && supplierDetailsList.supplierNumber === data.supplierNumber) {
          eligibleCompanyCodeAndTextList.push({value: data.companyCode, text: data.companyCode + ' - ' + data.companyCodeText})
        }
      })
      this.$emit("uniqueCompanyCodeList",eligibleCompanyCodeAndTextList)
    },
    setSupplierNameAndOptions(supplierName){
      this.toBeReturnedFieldObj.filteredName = supplierName
      this.toBeReturnedFieldObj.name = supplierName
      this.$refs.inputRef.value = supplierName
      this.isOpen = false
    },
    preventBlur(event){
      event.preventDefault();
    }
  },
};
</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #96c8da;
  overflow: auto;
  position: absolute;
  width: 100%;
  background: white;
  z-index: 99;
}

.autocomplete-results-height-100 {
  height: 150px;
}

.autocomplete-results-height-auto {
  height: auto;
}

.autocomplete-result {
  border-top: 1px solid #fafafa;
  list-style: none;
  text-align: left;
  padding: 0.78rem 0.85rem !important;
  font-family: artifaktElementRegular !important;
  font-size: 14px;
  cursor: pointer;
  white-space: normal;
  word-wrap: normal;
  line-height: 1em;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #fafafa;
  z-index: 13;
}

.icon-container {
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);
}
.loader {
  position: relative;
  height: 20px;
  width: 20px;
  display: inline-block;
  animation: around 5.4s infinite;
}

@keyframes around {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

.loader::after, .loader::before {
  content: "";
  background: white;
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  border-width: 2px;
  border-color: #333 #333 transparent transparent;
  border-style: solid;
  border-radius: 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  animation: around 0.7s ease-in-out infinite;
}

.loader::after {
  animation: around 0.7s ease-in-out 0.1s infinite;
  background: transparent;
}

</style>
